export const calculatePercentageChange = (data: { [key: string]: number }[], dataKey: string): string | null => {
  if (data.length === 0) return null;

  const startValue = data[0][dataKey];
  const endValue = data[data.length - 1][dataKey];

  if (startValue === undefined || endValue === undefined) return null;
  if (startValue === 0) return null;

  const percentage = Math.round((endValue / startValue - 1) * 100);
  return percentage > 0 ? `+${percentage}%` : `${percentage}%`;
};
